exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.typekit.net/srv0wme.css);", ""]);

// module
exports.push([module.id, "/*\r\n$breakpoint argument choices:\r\n- xs\r\n- sm\r\n- md\r\n- lg\r\n- xl\r\n*/\ndiv[data-v-fde5ede4] {\n  display: inline-block;\n}\ndiv button[data-v-fde5ede4] {\n    border: none;\n    padding: 1em 2em 1em 2em;\n    font-size: 1rem;\n    text-transform: uppercase;\n    background-color: #304048;\n    color: white;\n    cursor: pointer;\n}\n@media (max-width: 1200px) {\ndiv button[data-v-fde5ede4] {\n        font-size: calc(0.8875rem + 0.15vw) ;\n}\n}\ndiv button.sized[data-v-fde5ede4] {\n      width: 13rem;\n}\n", ""]);

// exports
